import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PolicyholderPropertyDetails = lazy(
  () => import('@pages/landing/PolicyholderPropertyDetails'),
);

export const PolicyholderPropertyDetailsRoutes: RouteObject[] = [
  {
    path: '/policyholder-property-details',
    element: (
      <React.Suspense>
        <PolicyholderPropertyDetails />
      </React.Suspense>
    ),
  },
];